import React from "react";
import { useFormContext } from "react-hook-form";
import { IInscription } from "../../../../../models/interfaces/IInscription";
import CpntFormSection from "../../../../../components/forms/CpntFormSection";
import CpntFormSectionContainer from "../../../../../components/forms/CpntFormSectionContainer";
import TextInput from "../../../../../components/forms/TextInput";
import SelectInput from "../../../../../components/forms/SelectInput";
import { validationMode } from "../../../../../config/helpers";
import { base64ToBlob } from "../../../../FO/inscription/utils/fileHelpers";

interface InscriptionFormComplementairesProps {
  data: IInscription;
  secteurActivites: any[];
  disabled: boolean;
}

const InscriptionFormComplementaires: React.FC<InscriptionFormComplementairesProps> = ({
  data,
  secteurActivites,
  disabled
}) => {
  const { register, watch, formState } = useFormContext();
  const watchedCommentaires = watch("Commentaires");

  const handleViewFile = (base64Data: string, fileName: string) => {
    const blob = base64ToBlob(base64Data);
    
    if (blob.type.startsWith('image/')) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const newWindow = window.open('', '_blank');
        if (newWindow && e.target?.result) {
          newWindow.document.write(`
            <!DOCTYPE html>
            <html>
              <head>
                <title>${fileName}</title>
                <style>
                  body {
                    margin: 0;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    min-height: 100vh;
                    background-color: #2d2d2d;
                  }
                  img {
                    max-width: 95%;
                    max-height: 95vh;
                    object-fit: contain;
                    box-shadow: 0 4px 6px rgba(0,0,0,0.3);
                  }
                </style>
              </head>
              <body>
                <img src="${e.target.result}" alt="${fileName}" />
              </body>
            </html>
          `);
          newWindow.document.close();
        }
      };
      reader.readAsDataURL(blob);
    } else {
      const fileURL = URL.createObjectURL(blob);
      window.open(fileURL, '_blank');
      setTimeout(() => URL.revokeObjectURL(fileURL), 100);
    }
  };

  return (
    <div className="card mb-3">
      <div className="card-header">
        <h6 className="mb-0 fw-bold">INFORMATIONS COMPLÉMENTAIRES</h6>
      </div>
      <div className="card-body">
        <CpntFormSection pSectionLabel="">
          <CpntFormSectionContainer ColumnsSize={12} ColumnsSizesMd={[6, 6]}>
            <TextInput
              label="GLN éditeur"
              type="number"
              formName="GLNEditeur"
              validationStyle={validationMode.classic}
              placeholder="Numéro à 13 chiffres"
              maxLength={13}
              disabled={disabled}
            />
            <TextInput
              label="Marque principale"
              formName="Marque"
              validationStyle={validationMode.classic}
              placeholder="Valeur"
              disabled={disabled}
            />
          </CpntFormSectionContainer>

          <CpntFormSectionContainer ColumnsSize={12} ColumnsSizesMd={[12]}>
            <SelectInput
              label="Secteur d'activité"
              formName="IdSecteurActivite"
              ismandatory={true}
              optionEmpty="Sélectionnez un secteur d'activité"
              validationStyle={validationMode.classic}
              options={secteurActivites}
              disabled={disabled}
            />
          </CpntFormSectionContainer>

          <CpntFormSectionContainer ColumnsSize={12} ColumnsSizesMd={[12]}>
            <TextInput
              label="Indicatif (Segment) ISBN"
              formName="ISBN"
              validationStyle={validationMode.classic}
              disabled={disabled}
              maxLength={25}
            />
          </CpntFormSectionContainer>

          <CpntFormSectionContainer ColumnsSize={12} ColumnsSizesMd={[12]}>
            <TextInput
              label="Référence ISBN13 / EAN complet"
              formName="ISBN13EANComplet"
              validationStyle={validationMode.classic}
              disabled={disabled}
              maxLength={40}
            />
          </CpntFormSectionContainer>

          <CpntFormSectionContainer ColumnsSize={12} ColumnsSizesMd={[12]}>
            <TextInput
              label="GLN distributeur"
              type="number"
              formName="GLNDiffuseur"
              validationStyle={validationMode.classic}
              placeholder="Numéro à 13 chiffres"
              maxLength={13}
              disabled={disabled}
            />
          </CpntFormSectionContainer>

          <CpntFormSectionContainer ColumnsSize={12} ColumnsSizesMd={[12]}>
            <div className="mb-3">
              <label className="d-block mb-2">
                Commentaire 
              </label>
              <textarea
                {...register("Commentaires")}
                className="form-control"
                rows={6}
                maxLength={600}
                disabled={disabled}
              />
              <div className="text-end mt-1" style={{ fontSize: "0.9em", color: "#6c757d" }}>
                Nb car(s) restant(s): {600 - (watchedCommentaires?.length || 0)}
              </div>
              {formState.errors.Commentaires && (
                <div className="text-danger mt-1">
                  {formState.errors.Commentaires.message as string}
                </div>
              )}
            </div>
          </CpntFormSectionContainer>

          {data.Fichiers && data.Fichiers.length > 0 && (
            <CpntFormSectionContainer ColumnsSize={12} ColumnsSizesMd={[12]}>
              <div className="mb-3">
                <label className="form-label text-muted small mb-2">FICHIERS</label>
                
                {data.Fichiers.map((fichier, index) => (
                  <div key={index} className="d-flex justify-content-between align-items-center mb-2 p-2 border rounded">
                    <span>{fichier.Nom}</span>
                    <button 
                      type="button" 
                      onClick={() => handleViewFile(fichier.Data, fichier.Nom)}
                      className="btn btn-sm btn-outline-primary"
                    >
                      <i className="bi bi-eye me-1"></i>Voir
                    </button>
                  </div>
                ))}
              </div>
            </CpntFormSectionContainer>
          )}
        </CpntFormSection>
      </div>
    </div>
  );
};

export default InscriptionFormComplementaires;
